export const validateDepenencies = ( currentConfiguration, deps ) => {

    if( !deps || !Array.isArray( deps ) || deps.length == 0 ) return true;

    let valid = true;

    deps.forEach( dep => {

        if( valid == true ){
            //still valid so continue.

            if( dep.on == true ){
                //on means make sure it exists in the current conguration.

                let ref_group = currentConfiguration[ dep.group_slug ];

                if( ref_group ){

                    if( Array.isArray( ref_group ) ){
                        //group value is an array, so check each one.

                        let slug_exists = false;

                        ref_group.forEach( v => {
                            
                            if( v.slug == dep.value_slug ){
                                //it's here so it does exist.

                                slug_exists = true;
                            }
                        } );

                        if ( slug_exists == false ) {
                            //slug DOES NOT exists which means it's invalid   
                            
                            valid = false;
                        }
                    } else {
                        
                        if( !ref_group.slug || ref_group.slug != dep.value_slug ){
                            //set to the wrong slug so it doesn't exist. which means it's invalid.

                            valid = false;
                        }
                    }
                } else {
                    //nothing exists for the group so it doesn't exist.

                    valid = false;
                }
            } else {
                //off means make sure it doesn't exist in the configuration.

                let ref_group = currentConfiguration[ dep.group_slug ];

                if( ref_group ){

                    if( Array.isArray( ref_group ) ){
                        //group value is an array, so check each one.

                        let slug_exists = false;

                        ref_group.forEach( v => {
                            
                            if( v.slug == dep.value_slug ){
                                //it's here so it does exist.

                                slug_exists = true;
                            }
                        } );

                        if ( slug_exists == true ) {
                            //slug DOES exists which means it's invalid                
            
                            valid = false;
                        }
                    } else {
                        
                        if( ref_group.slug == dep.value_slug ){
                            //set to the right slug so it does exist. which means it's invalid.

                            valid = false;
                        }
                    }
                }
            }
        }
    } );

    return valid
}